import React from 'react'

export const SELF = 'SELF'
export const MEDICARE = 'MEDICARE'
export const PRIVATE = 'PRIVATE'
export const OTHER = 'OTHER'
